export default [
  {
    path: window.pathApp + '/filiacao',
    name: 'filiacao',
    component: () => import('@/components/CadastroFiliado'),
    meta: {
      login: false,
      title: "Filie-se",
    },
  },
  {
    path: window.pathApp + '/termos-de-uso',
    name: 'termos-de-uso',
    component: () => import('@/components/TermosDeUso'),
    meta: {
      login: false,
      title: "Filie-se",
    },
  },
]



// WEBPACK FOOTER //
// ./src/router/routes/filiacao.js